interface AdminErrorStateProps {
  status?: "error" | "warning" | "success" | "notfound";
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  helpHref?: string;
}

const statusStyles: Record<NonNullable<AdminErrorStateProps["status"]>, string> = {
  error: "from-rose-500/20 to-rose-50 text-rose-700",
  warning: "from-amber-500/20 to-amber-50 text-amber-700",
  success: "from-emerald-500/20 to-emerald-50 text-emerald-700",
  notfound: "from-slate-500/15 to-slate-50 text-slate-700",
};

export default function AdminErrorState({
  status = "error",
  title,
  description,
  actionLabel,
  onAction,
  helpHref,
}: AdminErrorStateProps) {
  const tone = statusStyles[status] ?? statusStyles.error;

  return (
    <div className="workspace-panel rounded-3xl px-8 py-12 text-center">
      <div
        className={`mx-auto inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br text-2xl font-extrabold ${tone}`}
      >
        {status === "notfound" ? "404" : "!"}
      </div>

      <h2 className="mt-5 text-2xl font-bold text-slate-900">{title}</h2>
      {description && <p className="mx-auto mt-2 max-w-2xl text-sm text-slate-600">{description}</p>}

      <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="rounded-xl bg-[linear-gradient(135deg,#0a84ff,#0a5dd7)] px-4 py-2 text-sm font-semibold text-white shadow-[0_12px_20px_rgba(10,109,230,0.28)]"
          >
            {actionLabel}
          </button>
        )}

        {helpHref && (
          <a
            href={helpHref}
            className="rounded-xl border border-slate-300 bg-white/80 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100"
          >
            Yardim
          </a>
        )}
      </div>
    </div>
  );
}
